const env = process.env.NODE_ENV || 'development';

const apiEnvironment = {
  development: {
    // api: 'https://api.datvangvietnam.net/',
    api: '/',
    domainAdminSide: 'http://localhost:3000',
    domainUserSide: 'https://vietnamiz.com',
    // domainUserSide: 'https://datvangvietnam.net',
    domainName: '',
  },
  production: {
    // api: 'https://api.datvangvietnam.net/',
    // domainAdminSide: 'https://admin.datvangvietnam.net',
    // domainUserSide: 'https://datvangvietnam.net',
    // domainName: 'admin.datvangvietnam.net',
    api: 'https://api-new.vietnamiz.com/',
    domainName: 'admin-new.vietnamiz.com',
    domainAdminSide: 'https://admin-new.vietnamiz.com',
    domainUserSide: 'https://vietnamiz-new.vietnamiz.com',
  },
};

module.exports = apiEnvironment[env];
